import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import UpcomingReleases from "./UpcomingReleases";
import ReleaseNotes from "./ReleaseNotes";
import { Helmet } from "react-helmet-async";

const ChangeLog = () => {
  const location = useLocation();
  const title = "Software Test Management Release Notes and Updates";
  const description = "Stay updated with software test management release notes and updates, highlighting new features, fixes, and improvements to streamline QA and testing.";
  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta
          name="description"
          content={description}
        />

        <meta
          name="keywords"
          content="software test management release notes"
        />

        <link rel="canonical" href="https://frothtestops.com/change-log" />

        {/* Open Graph Tags */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://frothtestops.com${location.pathname}`} />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/images/og-image.jpg" />
      </Helmet>
      <div
        className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}
      >
        <Header />
        <UpcomingReleases />
        <ReleaseNotes />
        <Footer />
      </div>
    </>
  );
};

export default ChangeLog;
